import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { get_support_tickets_api } from "../../DAL/SupportTickets";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../Components/GeneralComponents/PageLoader";
import { useContent } from "../../hooks/useContent";
import CustomMUITable from "../../Components/GeneralComponents/CustomMUITable/CustomMUITable";
import moment from "moment/moment";
import { get_ticket_trash_api } from "../../DAL/SupportTickets";
import ConfirmationPopup from "../../Components/GeneralComponents/ConfirmationPopup";

const SupportTickets = () => {
  const navigate = useNavigate();
  const { setPageHeading } = useContent();
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("status");
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [updatedCases, setUpdatedCases] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedObject, setSelectedObject] = useState({});

  const loadCases = async (e) => {
    if (e) e.preventDefault();
    setIsLoadingPage(true);
    const result = await get_support_tickets_api({ search, sort });
    if (result.code === 200) {
      const tickets = result.tickets.map((ticket) => {
        const createdAt = moment(ticket.creation_timestamp).format(
          "DD-MM-YYYY HH:mm A"
        );
        return { ...ticket, createdAt };
      });
      setUpdatedCases(tickets);
    } else {
      toast.error(`${result.message}`);
    }
    setIsLoadingPage(false);
  };

  useEffect(() => {
    setPageHeading("Support Tickets");
    loadCases();
  }, []);

  const handleChangeSearch = (e) => setSearch(e.target.value);
  const handleChangeSort = (e) => setSort(e.target.value);

  const handleBack = () => navigate("/home");
  const handleCreate = (e) => navigate("/support-tickets/create-ticket");

  if (isLoadingPage) return <PageLoader />;

  const TABLE_HEAD = [
    { id: "number", label: "#", type: "number" },
    { id: "case_id", label: "Case ID" },
    { id: "case_title", label: "Case Title" },
    { id: "priority", label: "Priority" },
    { id: "status", label: "Current Status" },
    { id: "createdAt", label: "Created At" },
    {
      id: "action",
      label: "Action",
      type: "action",
    },
  ];

  const handleEdit = (data) => {
    navigate(`/support-tickets/edit-ticket/${data.case_id}`);
  };

  const handleDetail = (data) => {
    navigate(`/support-tickets/edit-ticket/${data.case_id}`);
  };
  const handleTrashSupportTicket = async () => {
    setIsDeleting(true);
    const result = await get_ticket_trash_api(selectedObject.case_id);
    if (result.code === 200) {
      setUpdatedCases((old) =>
        old.filter((data) => data.case_id !== selectedObject.case_id)
      );
      setIsDeleting(false);
      setOpenDelete(false);
      setSelectedObject(null);
      toast.success(`${result.message}`);
    } else {
      toast.error(`Error deleting support ticket: ${result.message}`);
    }
  };

  const handleDeleteClick = (item) => {
    setSelectedObject(item);
    setOpenDelete(true);
  };

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick: handleEdit,
    },
    {
      label: "Detail",
      icon: "gg:details-more",
      handleClick: handleDetail,
    },
    {
      label: "Move to Trash",
      icon: "ant-design:delete-twotone",
      handleClick: handleDeleteClick,
    },
  ];

  return (
    <div className="login-page">
      <div className="d-flex justify-content-center">
        <div className="container mx-auto">
          <div className="form-wrapper">
            <form onSubmit={loadCases}>
              <div className="row mb-3">
                <div className="col">
                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="cancel-button"
                      onClick={handleBack}
                    >
                      <Icon icon="mdi:arrow-left" /> Back
                    </button>
                    <button
                      type="button"
                      className="theme-button"
                      onClick={handleCreate}
                    >
                      <Icon icon="mdi:plus" /> Create New Case
                    </button>
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col">
                  <div className="search_sort_box d-flex gap-2 align-items-center">
                    <div className="form-group flex-1">
                      <label htmlFor="name">Search</label>
                      <div className="input-wrapper">
                        <Icon icon="mdi:magnify" className="input-icon" />
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Type a search string"
                          value={search}
                          onChange={handleChangeSearch}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Sort By</label>
                      <div className="input-wrapper">
                        <Icon
                          icon="mdi:filter-variant"
                          className="input-icon"
                        />
                        <select
                          value={sort}
                          onChange={handleChangeSort}
                          className="form-select"
                        >
                          <option value="status">Status</option>
                          <option value="priority">Priority</option>
                          <option value="creation_timestamp">
                            Creation Date
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="mt-1">
                      <button
                        type="submit"
                        className="theme-button mt-4"
                        onClick={loadCases}
                      >
                        Go
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <CustomMUITable
                TABLE_HEAD={TABLE_HEAD}
                data={updatedCases}
                MENU_OPTIONS={MENU_OPTIONS}
                hide_search={true}
              />
              <ConfirmationPopup
                openDelete={openDelete}
                setOpenDelete={setOpenDelete}
                title={
                  "Are you sure you want to move this support ticket to trash?"
                }
                handleAgree={handleTrashSupportTicket}
                isLoading={isDeleting}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportTickets;
